import { RequestResponseType } from './auth0.types';
import logger from '../../utils/logger';
import { refreshSession } from './auth0.utils';
import { getSession } from './auth0-session.service';

export const refreshOutdatedTokens = async (
  requestResponse: RequestResponseType,
) => {
  const session = await getSession({ requestResponse });
  if (
    session?.accessTokenExpiresAt &&
    session.refreshToken &&
    (session.accessTokenExpiresAt - 60) * 1000 < Date.now()
  ) {
    logger.info('Outdated session detected. Refreshing.');

    await refreshSession({
      session,
      requestResponse,
    });

    return getSession({ requestResponse });
  }

  return session;
};
